import OpenedImageGaleria from "./OpenedImageGaleria";

export default OpenedImageGaleria;
